import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { PageContent } from "@/components/common/page-content"
import { FirmAuthorisationActions } from "@/features/firms/components/firm-authorisation-actions"
import { FirmAuthorisationEmptyState } from "@/features/firms/components/firm-authorisation-empty-state"
import { FirmAuthorisationStatement } from "@/features/firms/components/firm-authorisation-statement"
import { FirmPermissionGroups } from "@/features/firms/components/firm-permission-groups"
import { firmRecordQueries } from "@/queries/firm-record"
import { firmQueries } from "@/queries/firms"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/authorisation/"
)({
  staticData: { attention: "firm.appointment" },
  loader: async ({ context, params }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(firmQueries.detail(params.firmId)),
      context.queryClient.ensureQueryData(
        firmRecordQueries.scope(params.firmId)
      ),
    ])
  },
  component: FirmAuthorisationPage,
})

/**
 * What this firm is proposed or appointed to do, grouped by area, with the
 * date it runs from. Its people, and their approvals, are on People.
 */
function FirmAuthorisationPage() {
  const { firmId } = Route.useParams()
  const { data: firm } = useSuspenseQuery(firmQueries.detail(firmId))

  return (
    <>
      <PageHeader
        title="Authorisation"
        actions={<FirmAuthorisationActions firm={firm} />}
      />

      <PageContent>
        <FirmAuthorisationEmptyState firm={firm} />
        <FirmAuthorisationStatement firm={firm} />
        <FirmPermissionGroups firm={firm} />
      </PageContent>
    </>
  )
}
